import React, { useState } from 'react'

import Constants from 'constants.js'
import ButtonGroup from 'components/common/ButtonGroup/ButtonGroup'

const items = [
    { label: 'Newest', value: Constants.FORUM.FORUM_SORT_NEW },
    { label: 'Top Ranked', value: Constants.FORUM.FORUM_SORT_TOP },
]

const ForumTabs = ({ onTabChange, className = '' }) => {
    const [activeItem, setActiveItem] = useState(items[1])

    return (
        <ButtonGroup
            className={className}
            active={activeItem}
            onChange={item => {
                setActiveItem(item)
                onTabChange(item.value)
            }}
            items={items}
        />
    )
}

export default React.memo(ForumTabs)
